/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetVatRateBaseRequest } from '../../models/get-vat-rate-base-request';
import { GetVatRateResponse } from '../../models/get-vat-rate-response';

export interface PostApiVatrateV1$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetVatRateBaseRequest
}

export function postApiVatrateV1$Json(http: HttpClient, rootUrl: string, params?: PostApiVatrateV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVatRateResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiVatrateV1$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetVatRateResponse>;
    })
  );
}

postApiVatrateV1$Json.PATH = '/private/v1/vat-rates';
